import styles from './EditProjectIterationsModal.module.css';

import addIcon from 'assets/svg/add-01.svg';
import iconDelete from 'assets/svg/delete-01.svg';

import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import Icon from 'helpers/components/Icon';
import { formatDate } from 'helpers/utils';
import { projectsStore } from '../../../../../store/mobx/projects.store';
import RegularButton from 'ui/RegularButton';
import IconButton from 'ui/IconButton';
import Tooltip from 'ui/Tooltip/index';
import Modal from 'ui/Modal';
import ProjectIterationStatus from '../../ViewEditProject/ProjectIterationStatus';
import useAlert from 'hooks/useAlert';
import { productionStore } from 'store/mobx/production.store';

const EditProjectIterationsModal = observer(({ setModalOpened }) => {
  const { selectedProject, upsertProjectIteration, removeProjectIteration } = projectsStore;
  const { selectedProductionId, reset } = productionStore;
  const { showAlert } = useAlert();
  const [projectIterations, setProjectIterations] = useState([]);

  useEffect(() => {
    if (!selectedProject?.iterations) return;
    setProjectIterations(selectedProject?.iterations);
  }, [selectedProject?.iterations]);

  const closeModal = () => setModalOpened(false);

  const handleAddIteration = async () => {
    await upsertProjectIteration(selectedProject.id);
  };

  const handleDeleteIteration = async (id) => {
    const result = await removeProjectIteration(id);
    if (!result.success) errorDeleteIterationAlert(result.error_code, result.error);
    else {
      if (selectedProductionId === id) reset();
    }
  };

  const errorDeleteIterationAlert = (code, message) => {
    showAlert(` Код № ${code}${message ? ` - ${message}` : ''}!`, 'error');
  };

  const Iteration = ({ key, iteration }) => (
    <>
      <div className={styles.iterationWrapper} key={key}>
        <div className={styles.iterationInfo}>
          <div className={styles.iteration}>{formatDate(new Date(iteration.created_at), true)}</div>
          <div className={styles.iteration}>{iteration.name.replace('Iteration', 'Цикл')} -</div>
          <ProjectIterationStatus status={iteration} />
        </div>
        <Tooltip text="Удалить">
          <IconButton
            onClick={() => handleDeleteIteration(iteration.id)}
            icon={iconDelete}
            size="16"
            color="primary"
          />
        </Tooltip>
      </div>
      <div className={styles.divider} />
    </>
  );

  return (
    <Modal hideDefaultFooter={true} title="Редактирование циклов" onClose={closeModal}>
      <div className={styles.container}>
        {(projectIterations?.length &&
          projectIterations?.map((iteration) => (
            <Iteration key={iteration.id} iteration={iteration} />
          ))) || <div className={styles.notIteration}>Циклы не добавлены</div>}
      </div>
      <div>
        <RegularButton
          onClick={handleAddIteration}
          appendIcon={<Icon color={'#ffffff'} src={addIcon} width={'12px'} height={'12px'} />}
          className={styles.button}
          color="primary"
          variant="flat"
          text="Добавить цикл"
        />
      </div>
    </Modal>
  );
});

export default EditProjectIterationsModal;
